// Signup only — Stripe, plans, captcha (heavier than auth_lite).
import "../auth_turbo"
import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

import PasswordToggleController from "../controllers/password_toggle_controller"
import SignupController from "../controllers/signup_controller"
import AuthFormController from "../controllers/auth_form_controller"
import AuthLoaderController from "../controllers/auth_loader_controller"
import AuthToastController from "../controllers/auth_toast_controller"
import OnboardingProgressController from "../controllers/onboarding_progress_controller"
import BrandShowcaseController from "../controllers/brand_showcase_controller"

application.register("auth-toast", AuthToastController)
application.register("onboarding-progress", OnboardingProgressController)
application.register("brand-showcase", BrandShowcaseController)
application.register("password-toggle", PasswordToggleController)
application.register("signup", SignupController)
application.register("auth-form", AuthFormController)
application.register("auth-loader", AuthLoaderController)

import "../stylesheets/auth_pack.scss"
